import React from "react";
import styled from "styled-components";

const Svg = styled.svg`
  position: relative;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s ease;
  fill: #99959d;
  fill-rule: evenodd;
`;

//Основные иконки
export let InfoIcon = () => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <path
      d="M942.01,299.952a8.055,8.055,0,1,0,8.055,8.055A8.056,8.056,0,0,0,942.01,299.952Zm-1,4.038h2.006v1.975h-2.006V303.99Zm2.978,7.97H940v-1h1v-2.95h-1v-1h3.01v3.953h0.972v1Z"
      transform="translate(-933.016 -299)"
    />
  </Svg>
);

export const GiftIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.002"
    height="18.002"
    viewBox="0 0 18.002 18.002"
  >
    <path
      d="M21970,22216h-14v-7h-1v-7h3.5a2.475,2.475,0,0,1-.5-1.5,2.508,2.508,0,0,1,2.5-2.5h2a2.492,2.492,0,0,0,3,0h2a2.5,2.5,0,0,1,2,4h3.5v7h-1v7Zm0-2v-5h-5v5Zm-7,0v-5h-5v5Zm8-7v-3h-14v3Zm-6-6.5v.5h2.5a.5.5,0,0,0,.5-.5.508.508,0,0,0-.5-.5h-2A.508.508,0,0,0,21965,22200.5Zm-5,0a.5.5,0,0,0,.5.5h2.5v-.5c0-.021,0-.043,0-.064a.51.51,0,0,0-.5-.437h-2A.508.508,0,0,0,21960,22200.5Z"
      transform="translate(-21954.998 -22198.002)"
      fill="currentColor"
    />
  </svg>
);

export const AdviceIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <path
      d="M0,18,9,0l9,18Zm3.236-2H14.764L9,4.472ZM8,15V13h2v2Zm0-3V8h2v4Z"
      fill="currentColor"
    />
  </svg>
);

export const HotIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="42"
    viewBox="0 0 42 42"
  >
    <defs>
      <clipPath id="a">
        <rect width="42" height="42" fill="none" />
      </clipPath>
    </defs>
    <g clipPath="url(#a)">
      <path d="M.5.5h42v42Z" transform="translate(-0.5 -0.5)" fill="#9c0401" />
      <text
        transform="translate(18.208 10.258) rotate(45)"
        fill="#fff"
        fontSize="11"
        fontFamily="Roboto-Black, Roboto"
        fontWeight="800"
      >
        <tspan x="0" y="0">
          HOT
        </tspan>
      </text>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/AccountType/Icons.js